export async function turboRequest(
  url,
  {
    method = "POST",
    params = {},
    turboStream = true,
    onSuccess = null,
    onError = null
  } = {}
) {
  try {
    const response = await fetch(url, {
      method,
      headers: {
        "X-CSRF-Token":
          document.querySelector('meta[name="csrf-token"]')?.content || "",
        "Content-Type": "application/json",
        Accept: turboStream
          ? "text/vnd.turbo-stream.html"
          : "application/json"
      },
      body: method === "GET" ? undefined : JSON.stringify(params)
    })

    if (!response.ok) {
      throw new Error(`Request failed with status ${response.status}`)
    }

    const result = await response.text()

    if (turboStream) {
      Turbo.renderStreamMessage(result)
    }

    if (onSuccess) {
      onSuccess(result, response)
    }

    return result
  } catch (error) {
    console.error(error)

    if (onError) {
      onError(error)
    }

    throw error
  }
}
